import { render, staticRenderFns } from "./DepartmentDiscountB2b.vue?vue&type=template&id=25f7932a"
import script from "./DepartmentDiscountB2b.vue?vue&type=script&lang=js"
export * from "./DepartmentDiscountB2b.vue?vue&type=script&lang=js"
import style0 from "./DepartmentDiscountB2b.vue?vue&type=style&index=0&id=25f7932a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports